import { displayError } from '../helpers';
import { printSalesInvoice } from '../services/SalesInvoiceServices';
import { openPdfInApp } from './openPdfInApp';

export function fetchAndShowInvoicePdf(cookies, invoiceId, options = {}) {
    return printSalesInvoice(cookies, invoiceId)
        .then((pdfResponse) => {
            openPdfInApp(pdfResponse, {
                title: options.title || 'Invoice PDF',
                onClose: options.onClose,
            });
        })
        .catch((error) => {
            displayError(error?.response?.data || error, options.errorTitle || 'Print Failed');
        });
}
